export class SendNotificationModel{
    public crmUserId:number;
    public sessionToken:string;
    public title:string;
    public description:string;
    public date:string;

}